"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    clickable: {
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
    },
};
//# sourceMappingURL=ClickableLogo.styles.js.map